import React from 'react';
import Icon from '../../../components/AppIcon';

const QuestionnaireProgress = ({ 
  currentQuestion, 
  totalQuestions, 
  completedQuestions = 0,
  className = '' 
}) => {
  const progressPercentage = (completedQuestions / totalQuestions) * 100;
  const isComplete = completedQuestions === totalQuestions;

  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="BarChart3" size={18} className="text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground">Assessment Progress</h3>
              <p className="text-sm text-muted-foreground">
                Question {currentQuestion} of {totalQuestions}
              </p>
            </div>
          </div>
          
          <div className="text-right">
            <div className="text-2xl font-bold text-primary font-mono">
              {Math.round(progressPercentage)}%
            </div>
            <div className="text-xs text-muted-foreground">Complete</div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="space-y-2">
          <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-500 ease-out rounded-full"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>Started</span>
            <span className="hidden sm:inline">In Progress</span>
            <span>{isComplete ? 'Complete' : 'Remaining'}</span>
          </div>
        </div>

        {/* Step Indicators */}
        <div className="flex items-center justify-between">
          {Array.from({ length: totalQuestions }, (_, index) => {
            const questionNumber = index + 1;
            const isCompleted = questionNumber <= completedQuestions;
            const isCurrent = questionNumber === currentQuestion;
            
            return (
              <div
                key={questionNumber}
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium
                  transition-all duration-200
                  ${isCompleted
                    ? 'bg-success text-success-foreground shadow-sm'
                    : isCurrent
                    ? 'bg-primary text-primary-foreground shadow-md ring-2 ring-primary/20'
                    : 'bg-muted text-muted-foreground'
                  }
                `}
              >
                {isCompleted ? (
                  <Icon name="Check" size={14} />
                ) : (
                  <span className="font-mono">{questionNumber}</span>
                )}
              </div>
            );
          })}
        </div>

        {/* Status Message */}
        <div className="text-center">
          {isComplete ? (
            <div className="flex items-center justify-center space-x-2 text-sm text-success">
              <Icon name="CheckCircle" size={16} />
              <span>Assessment completed successfully!</span>
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">
              {totalQuestions - completedQuestions} question{totalQuestions - completedQuestions !== 1 ? 's' : ''} remaining
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireProgress;